import { useState } from 'react'
import { enregistrerTheme, lireTheme, type Theme } from '../lib/theme'
import { layout } from '../design/tokens'

/**
 * Bascule clair / sombre / système.
 *
 * Trois états dans un seul bouton plutôt qu'un interrupteur à deux : sans le troisième, on ne
 * peut plus revenir au réglage du téléphone une fois qu'on a touché au bouton.
 */
const SUIVANT: Record<Theme, Theme> = {
  systeme: 'sombre',
  sombre: 'clair',
  clair: 'systeme',
}

const LIBELLE: Record<Theme, string> = {
  systeme: 'Thème : réglage du téléphone',
  sombre: 'Thème : sombre',
  clair: 'Thème : clair',
}

export function BoutonTheme() {
  const [theme, setTheme] = useState<Theme>(lireTheme)

  return (
    <button
      type="button"
      aria-label={LIBELLE[theme]}
      title={LIBELLE[theme]}
      onClick={() => {
        const suivant = SUIVANT[theme]
        enregistrerTheme(suivant)
        setTheme(suivant)
      }}
      className="flex shrink-0 items-center justify-center rounded-full border border-border bg-card text-accent"
      style={{ width: layout.minimumTouchTarget, height: layout.minimumTouchTarget }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {theme === 'sombre' ? (
          /* Lune pleine : le sombre est imposé. */
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" fill="currentColor" />
        ) : theme === 'clair' ? (
          /* Soleil : le clair est imposé. */
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19" />
          </>
        ) : (
          /* Moitié-moitié : c'est le téléphone qui décide. */
          <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 3a9 9 0 0 0 0 18z" fill="currentColor" stroke="none" />
          </>
        )}
      </svg>
    </button>
  )
}
